import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Actions
import {
  setUserInfo,
  setUserLoading,
  setBuildInfo,
  setDataAccessLevelOptions,
  setStudyStatusOptions,
  setOrganismOptions,
  setOrganizationsOptions,
  setSponsorsOptions,
  setDataTypeOptions,
  setExposureTypeOptions,
  setTruthDataOptions,
  setTags,
  setModelTypesOptions,
  setModelExposureTypesOptions,
  setPageTools,
  setPageLoading
} from '../redux/actions';

// React Router
import {
  BrowserRouter as Router,
  Link as LinkRouter
} from 'react-router-dom';

// App
import {buildSecureApiUrl, buildApiUrl, performGetFetch} from '../utils/APIUtils.js';

function GlobalLoader({ dispatch, userInfo, sponsor_options, dal_options, study_status_options, organism_options, pageInfo, ...props }) {
  let navigate = useNavigate();
  const userEmail = useRef(userInfo.email);

  useEffect(() => {
    if (!userEmail.current) {
      async function fetchData() {
        await loadUserInfo(dispatch, navigate);
      }
      fetchData().catch();
    }
  }, [dispatch, navigate]);

  /*useEffect(() => {
    if (!pageInfo?.tools_page) {
      async function fetchData() {
        await loadPageInfo(dispatch, toolsPage.current);
      }
      fetchData().catch();
    }
  }, [dispatch, navigate, pageInfo]);*/

  useEffect(() => {
    async function fetchData() {
      loadStudyRegistrationOptions(dispatch);
      if (pageInfo?.feature_analyst_workbench) {
        loadAlgorithmRegistrationOptions(dispatch);
      }
      loadBuildInfo(dispatch);
    }
    fetchData().catch();
  }, [dispatch, pageInfo]);

  return (<></>);
}

export function loadUserInfo(dispatch, navigate) {
  dispatch(setUserLoading(true));

  const main_request = async () => {
    performGetFetch.call(this, 'whoami',
    (result) => {
      // Whoami returns an expanded userInfo response
      let userInfo = {
        first_name: result.first_name,
        last_name: result.last_name,
        display_name: result.display_name,
        email: result.email,
        user_guid: result.user_guid,
        logged_in: result.logged_in,
        email_verified: result.email_verified,
        ethics_pledge: result.ethics_pledge,
        ethics_pledge_details: result.ethics_pledge_details,
        attributes: {
          title: result?.attributes?.title,
          ORCID: result?.attributes?.ORCID,
          eRA: result?.attributes?.eRA
        },
        organization: {
          organization: result?.organization?.organization,
          ROR: result?.organization?.ROR,
          eRA: result?.organization?.eRA,
          location: result?.organization?.location,
        },
        can_create_study: result.can_create_study,
        can_create_model: result.can_create_model,
        can_create_tool: result.can_create_tool,
        available_resources: result.available_resources,
        my_team: result.my_team
      };

      dispatch(setUserInfo(userInfo));
      dispatch(setUserLoading(false));
      checkUserAccountRedirect(userInfo, navigate);

      return userInfo;
    },
    (error) => {
      dispatch(setUserLoading(false));
      console.warn(error);
    })
  }

  if (!global.is_logged_in_secure) {
    // console.log('checking on login status first.');
    const our_request = async () => {
      let response = await fetch(buildSecureApiUrl('whoami'), {redirect: 'error', cache: 'no-store'});
      if (response.ok) {
        global.is_logged_in_secure = true;
        window._env_.APP_SECURE_API = window._env_.APP_API.replace('/api', '/secure/api');
        // console.log('Confirmed: user is already logged in');
      }
    }
    return our_request()
      .then((response) => {
        // console.log('now getting userInfo.');
        return main_request().catch();
      }).catch();
  } else {
    // console.log('getting real userInfo.');
    return main_request().catch();
  }
}

function loadStudyRegistrationOptions(dispatch) {
  // Ask API for list of collaborating organizations
  performGetFetch.call(this, 'organizations',
    (result) => {
      dispatch(setOrganizationsOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of sponsor organizations
  performGetFetch.call(this, 'sponsors?include_sub_organizations=false',
    (result) => {
      dispatch(setSponsorsOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of access levels
  performGetFetch.call(this, 'dal',
    (result) => {
      dispatch(setDataAccessLevelOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of status
  performGetFetch.call(this, 'status',
    (result) => {
      dispatch(setStudyStatusOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of organism
  performGetFetch.call(this, 'organism',
    (result) => {
      dispatch(setOrganismOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );
/*
  // Ask API for list of data type tags
  performGetFetch.call(this, 'tags?type=data_type',
    (result) => {
      dispatch(setDataTypeOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of exposure_type tags
  performGetFetch.call(this, 'tags?type=exposure',
    (result) => {
      dispatch(setExposureTypeOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of truth_data tags
  performGetFetch.call(this, 'tags?type=truth',
    (result) => {
      if (Array.isArray(result)) {
        dispatch(setTruthDataOptions(result));
      }
    },
    (error) => {
      console.warn(error);
    }
  );*/

  // Ask API for list of all tags
  performGetFetch.call(this, 'tags/',
    (result) => {
      // console.warn('global loader tags', result);
      if (Array.isArray(result)) {
        dispatch(setTags(result));
      }
    },
    (error) => {
      // console.warn(error);
    }
  );
}

function loadAlgorithmRegistrationOptions(dispatch) {
  // Ask API for list of model_types
  performGetFetch.call(this, 'aw/model_types',
    (result) => {
      dispatch(setModelTypesOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );

  // Ask API for list of model_exposure_types
  performGetFetch.call(this, 'aw/exposure_types',
    (result) => {
      dispatch(setModelExposureTypesOptions(result));
    },
    (error) => {
      console.warn(error);
    }
  );
}

function loadBuildInfo(dispatch) {
  // Ask API for list of access levels
  document.title = window._env_.APP_NAME;
  performGetFetch.call(this, 'version',
    (result = { branch: '', build: '', build_date: '' }) => {
      //console.log(result);
      let newBuildInfo = result.branch + ' #' + result.build + ' (' + result.build_date + ')';
      dispatch(setBuildInfo(newBuildInfo));
    },
    (error) => {
      console.warn(error);
    }
  );
}

/*function loadPageInfo(dispatch, currentToolsPage) {
  dispatch(setPageLoading(true));

  if (!currentToolsPage) {
    const our_request = async () => {
      let response = await fetch(buildApiUrl('tools/count'), {redirect: 'error'});
      if (response.ok) {
        return response.json();
      }
    }
    return our_request().then((response) => {
      let toolsPage = response?.number_of_tools > 0 || false;
      dispatch(setPageTools(toolsPage));
      dispatch(setPageLoading(false));
    }).catch(() => {
      dispatch(setPageTools(false));
      dispatch(setPageLoading(false));
    });
  }
}*/

function checkUserAccountRedirect(userInfo, navigate) {
  if (!userInfo) {
    return false;
  }

  if (!userInfo.logged_in) {
    // Redirect to Anon landing page
    /*
    navigate('/home', { replace: true });
    */
  }
  // Check if the user's account has been verified
  if (!userInfo.email_verified) {
    // Redirect to the Unverified page
    /*
    navigate('/unverified', { replace: true });
    */
  } 
  // Check if the user has accepted the ethics pledge
  else if (!userInfo.ethics_pledge) {
    // Reroute to the ethics pledge page
    navigate('/ethicspledge');
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo,
    sponsor_options: state.studyRegistrationOptions.sponsor_options,
    dal_options: state.studyRegistrationOptions.dal_options,
    study_status_options: state.studyRegistrationOptions.study_status_options,
    organism_options: state.studyRegistrationOptions.organism_options,
    pageInfo: state.pageInfo
  }
}

export default connect(mapStateToProps)(GlobalLoader);
